module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/XfxW9W/tc-custom/9781783408467.jpg?1728851698478",
      "alt": "This image is the cover for the book Foul Deeds & Suspicious Deaths in Cumbria, Foul Deeds & Suspicious Deaths"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Foul Deeds & Suspicious Deaths in Cumbria, Foul Deeds & Suspicious Deaths\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The criminal cases vividly described by Nicholas Corder in this gripping book take the reader on a journey into the dark secret side of Cumbria's long history. The hills, villages and market towns of this famous landscape have been the setting for a series of horrific, bloody, sometimes bizarre incidents over the centuries. From crimes of brutal premeditation to crimes born of passion or despair, the whole range of human weakness and wickedness is represented here. Swindlers, conmen, smugglers, pirates, child killers, deserters, fraudsters, robbers and common murderers people these pages, along with their victims. There are descriptions of public executions and instances of extraordinary domestic cruelty and malice that ended in death. Unforgettable local cases are reconstructed—the extraordinary career of the imposter John Hatfield, the Whitehaven raid of John Paul Jones, the unsolved murder of poor Lucy Sands, and many more. Nicholas Corder's chronicle of Cumbria's hidden history will be compelling reading for anyone who is interested in the sinister side of human nature.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nicholas Corder\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0